import { Transforms, Node, Element, Editor } from 'slate'
import { LIST_TYPES } from './utils'
import { Registry } from '@react-registry'

export const withList = (editor: Editor): Editor => {
  const { normalizeNode } = editor

  editor.normalizeNode = (entry) => {
    // Remove the 'id' attribute using Transforms
    Transforms.setNodes(
      editor,
      { id: undefined } as Partial<Node>, // Set `id` to undefined to remove it
      {
        match: (node) =>{
            if(Element.isElement(node) && LIST_TYPES.includes(node?.['type']) && node?.['id'] !== undefined){
                return true
            }
            return false
        },
        mode: 'all',
        at: [0]
      }
    )

    // Call the original normalizeNode
    normalizeNode(entry)
  }

  return editor
}

Registry.register(withList, { id: 'withList', registry: 'v2.plugin' })
